// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1367":"c1a1f6ce","2547":"c11c762b","3614":"7fec50dc","4044":"08f3d62b"}[chunkId] + ".chunk.css";
};